'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _phaser = require('phaser');

var _phaser2 = _interopRequireDefault(_phaser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Spike = function (_Phaser$Sprite) {
  _inherits(Spike, _Phaser$Sprite);

  function Spike(game, x, y, image) {
    _classCallCheck(this, Spike);

    var _this = _possibleConstructorReturn(this, (Spike.__proto__ || Object.getPrototypeOf(Spike)).call(this, game, x, y, image));

    _this.anchor.set(0.5);
    _this.spikeUp = true;
    _this.game.physics.enable(_this);
    _this.body.allowGravity = false;
    _this.body.immovable = true;
    _this.game.time.events.loop(1500, _this.updateSpike, _this);
    return _this;
  }

  _createClass(Spike, [{
    key: 'updateSpike',
    value: function updateSpike() {
      if (this.spikeUp) {
        this.position.y -= 30;
        this.spikeUp = false;
      } else {
        this.position.y += 30;
        this.spikeUp = true;
      }
    }
  }]);

  return Spike;
}(_phaser2.default.Sprite);

exports.default = Spike;


//////////////////
// WEBPACK FOOTER
// ./src/sprites/Spike.js
// module id = 340
// module chunks = 0